var EHDI = EHDI || Object.create(null);

EHDI.manager = EHDI.manager || Object.create(null);

EHDI.manager.AchievementManager = function() {
    
    var _this = this;
    var _data;
    
    var _achieveData;
    var _achievementPopup;
    
    var initData = function(){
        _achieveData = EHDI.Assets.fetch( "achievement_data" );
        _data = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.achieveID) || null;
        
        if( _data === null ){
            _data = {
                firstCatch: false,
                gotHeavy: false, 
                caughtNothing: false,
                splashing: { count: 0, finished: false },
                ribbit: { count: 0, finished: false },
                flies: { count: 0, finished: false },
                triedPower: { id: [], finished: false },
                caughtAllFish: false,
                caughtAll: { fish: [], power: [], junk: [], finished: false },
                record: { broken: [], finished: false }
            };
            
            var commonData = EHDI.Assets.fetch( "rarity_0" );
            var uncommonData = EHDI.Assets.fetch( "rarity_1" );
            var rareData = EHDI.Assets.fetch( "rarity_2" );
            
            var fishCount = commonData.fish.length + uncommonData.fish.length + rareData.fish.length;
            var powerCount = commonData.powerup.length + uncommonData.powerup.length + rareData.powerup.length;
            var junkCount = commonData.junk.length + uncommonData.junk.length + rareData.junk.length;
            
            for( var i = 0; i < 4; i++ ){ _data.triedPower.id.push( false ); }
            for( var i = 0; i < fishCount; i++ ){ _data.caughtAll.fish.push( false ); }
            for( var i = 0; i < powerCount; i++ ){ _data.caughtAll.power.push( false ); }
            for( var i = 0; i < junkCount; i++ ){ _data.caughtAll.junk.push( false ); }
            for( var i = 0; i < fishCount; i++ ){ _data.record.broken.push( false ); }
        }
    }
    
    this.setAchievementPopup = function( popup ){
        _achievementPopup = popup;
    }
    
    this.getUnlockedStates = function(){
        var states = [];
        
        states.push( _data.firstCatch );
        states.push( _data.gotHeavy );
        states.push( _data.caughtNothing );
        states.push( _data.splashing.finished );
        states.push( _data.ribbit.finished );
        states.push( _data.flies.finished );
        states.push( _data.triedPower.finished );
        states.push( _data.caughtAllFish );
        states.push( _data.caughtAll.finished );
        states.push( _data.record.finished );
        
        return states;
    }
    
    this.updateFirstCatch = function(){
        if( _data.firstCatch ) return;
        _data.firstCatch = true;
        
        _achievementPopup.showNotification( _achieveData.achievement[0] );
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
    }
    
    this.updateHeavyCatch = function(){
        if( _data.gotHeavy ) return;
        _data.gotHeavy = true;
        
        _achievementPopup.showNotification( _achieveData.achievement[1] );
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
    }
    
    this.updateCaughtNothing = function(){
        if( _data.caughtNothing ) return;
        _data.caughtNothing = true;
        
        _achievementPopup.showNotification( _achieveData.achievement[2] );
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
    }
    
    this.updateSplashing = function(){
        if( _data.splashing.finished ) return;
        _data.splashing.count += 1;
        
        if( _data.splashing.count >= 50 ){
            _data.splashing.finished = true;
            _achievementPopup.showNotification( _achieveData.achievement[3] );
        }
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
    }
    
    this.updateFrogTapped = function(){
        if( _data.ribbit.finished ) return;
        _data.ribbit.count += 1;
        
        if( _data.ribbit.count >= 20 ){
            _data.ribbit.finished = true;
            _achievementPopup.showNotification( _achieveData.achievement[4] );
        }
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
    }
    
    this.updateDragonflyTapped = function(){
        if( _data.flies.finished ) return;
        _data.flies.count += 1;
        
        if( _data.flies.count >= 30 ){
            _data.flies.finished = true;
            _achievementPopup.showNotification( _achieveData.achievement[5] );
        }
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
    }
    
    this.updateTriedPower = function( index ){
        if( _data.triedPower.finished ) return;
        _data.triedPower.id[ index ] = true;
        
        var allTried = true;
        for( var i = 0; i < _data.triedPower.id.length; i++ ){
            if( !_data.triedPower.id[ i ] ){
                allTried = false;
                break;
            }
        }
        
        if( allTried ){
            _data.triedPower.finished = true;
            _achievementPopup.showNotification( _achieveData.achievement[6] );
        }
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
    }
    
    this.updateFishCaught = function( index ){
        if( _data.caughtAll.finished ) return;
        _data.caughtAll.fish[ index ] = true;
        
        checkAllFish();
        checkCaughtAll();
    }
    
    this.updatePowerCaught = function( index ){
        if( _data.caughtAll.finished ) return;
        _data.caughtAll.power[ index ] = true;
        
        checkCaughtAll();
    }
    
    this.updateJunkCaught = function( index ){
        if( _data.caughtAll.finished ) return;
        _data.caughtAll.junk[ index ] = true;
        
        checkCaughtAll();
    }
    
    var checkAllFish = function(){
        if( _data.caughtAllFish ) return true;
        
        for( var i = 0; i < _data.caughtAll.fish.length; i++ ){
            if( !_data.caughtAll.fish[ i ] ) return false;
        }
        
        _data.caughtAllFish = true;
        _achievementPopup.showNotification( _achieveData.achievement[7] );
        return true;
    }
    
    var checkCaughtAll = function(){
        var caughtAll = true;
        var i = 0;
        
        if( !_data.caughtAllFish ) caughtAll = false;
        
        for( i = 0; i < _data.caughtAll.power.length; i++ ){
            if( !caughtAll ) break;
            if( !_data.caughtAll.power[ i ] ) caughtAll = false;
        }
        
        for( i = 0; i < _data.caughtAll.junk.length; i++ ){
            if( !caughtAll ) break;
            if( !_data.caughtAll.junk[ i ] ) caughtAll = false;
        }
        
        if( caughtAll ){
            _data.caughtAll.finished = true;
            _achievementPopup.showNotification( _achieveData.achievement[8] );
        }
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
    }
    
    this.updateRecord = function( index ){
        if( _data.record.finished ) return;
        _data.record.broken[ index ] = true;
        
        var brokenAll = true;
        for( i = 0; i < _data.record.broken.length; i++ ){
            if( !brokenAll ) break;
            if( !_data.record.broken[ i ] ) brokenAll = false;
        }
        
        if( brokenAll ){
            _data.record.finished = true;
            _achievementPopup.showNotification( _achieveData.achievement[9] );
        }
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
    }
    
    this.checkAllUnlocked = function(){
        var states = _this.getUnlockedStates();
        var allUnlocked = true;
        
        for( var i = 0; i < states.length; i++ ){
            if( !states[i] ){
                allUnlocked = false;
                break;
            }
        }
        
        if( allUnlocked && EHDI.GAME.gameScene ){
            EHDI.GAME.gameScene.endGame();
        }
    }
    
    this.checkAchievementProgress = function( index ){
        switch( index ){
            case 0:
                if( _data.firstCatch )  return { count: 1, goal: 1 };
                else                    return { count: 0, goal: 1 };
                break;
                
            case 1:
                if( _data.gotHeavy )    return { count: 1, goal: 1 };
                else                    return { count: 0, goal: 1 };
                break;
                
            case 2:
                if( _data.caughtNothing )   return { count: 1, goal: 1 };
                else                        return { count: 0, goal: 1 };
                break;
                
            case 3:
                return { count: _data.splashing.count, goal: 50 };
                break;
                
            case 4:
                return { count: _data.ribbit.count, goal: 20 };
                break;
                
            case 5:
                return { count: _data.flies.count, goal: 30 };
                break;
                
            case 6:
                var tried = 0;
                for( var i = 0; i < _data.triedPower.id.length; i++ ){
                    if( _data.triedPower.id[ i ] ) tried++;
                }
                return { count: tried, goal: _data.triedPower.id.length };
                break;
                
            case 7:
                var caught = 0;
                for( var i = 0; i < _data.caughtAll.fish.length; i++ ){
                    if( _data.caughtAll.fish[ i ] ) caught++;
                }
                return { count: caught, goal: _data.caughtAll.fish.length };
                break;
                
            case 8:
                var caught = 0;
                var max = 0;
                for( var i = 0; i < _data.caughtAll.fish.length; i++ ){
                    if( _data.caughtAll.fish[ i ] ) caught++;
                    max++;
                }
                
                for( i = 0; i < _data.caughtAll.power.length; i++ ){
                    if( _data.caughtAll.power[ i ] ) caught++;
                    max++;
                }

                for( i = 0; i < _data.caughtAll.junk.length; i++ ){
                    if( _data.caughtAll.junk[ i ] ) caught++;
                    max++;
                }
                return { count: caught, goal: max };
                break;
                
            case 9:
                var broken = 0;
                for( i = 0; i < _data.record.broken.length; i++ ){
                    if( _data.record.broken[ i ] ) broken++;
                }
                return { count: broken, goal: _data.record.broken.length };
                break;
        }
    }
    
    this.pauseAchievementNotif = function( status ){ _achievementPopup.pauseTimeline( status ); }
    
    // temp
    this.forceUnlock = function(){
        if( !_data.firstCatch ){
            _data.firstCatch = true;
            _achievementPopup.showNotification( _achieveData.achievement[0] );
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
            return;
        }
        else if( !_data.gotHeavy ){
            _data.gotHeavy = true;
            _achievementPopup.showNotification( _achieveData.achievement[1] );
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
            return;
        }
        else if( !_data.caughtNothing ){
            _data.caughtNothing = true;
            _achievementPopup.showNotification( _achieveData.achievement[2] );
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
            return;
        }
        else if( !_data.splashing.finished ){
            _data.splashing.finished = true;
            _achievementPopup.showNotification( _achieveData.achievement[3] );
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
            return;
        }
        else if( !_data.ribbit.finished ){
            _data.ribbit.finished = true;
            _achievementPopup.showNotification( _achieveData.achievement[4] );
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
            return;
        }
        else if( !_data.flies.finished ){
            _data.flies.finished = true;
            _achievementPopup.showNotification( _achieveData.achievement[5] );
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
            return;
        }
        else if( !_data.triedPower.finished ){
            _data.triedPower.finished = true;
            _achievementPopup.showNotification( _achieveData.achievement[6] );
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
            return;
        }
        else if( !_data.caughtAllFish ){
            _data.caughtAllFish = true;
            _achievementPopup.showNotification( _achieveData.achievement[7] );
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
            return;
        }
        else if( !_data.caughtAll.finished ){
            _data.caughtAll.finished = true;
            _achievementPopup.showNotification( _achieveData.achievement[8] );
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
            return;
        }
        else if( !_data.record.finished ){
            _data.record.finished = true;
            _achievementPopup.showNotification( _achieveData.achievement[9] );
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.achieveID, _data);
            return;
        }
    }
    
    initData();
}

EHDI.manager.AchievementManager.prototype = Object.create(null);